import React, {useState} from 'react';

import FilterBarAccordion from 'components/FilterBarAccordion';
import OfferTypesFilterSelector, {
  OfferTypesFilterSelectorProps,
} from 'components/Offers/OfferTypesFilterSelector';

import OfferFilter from '../Filter';

const OfferTypesFilter: React.FC<OfferTypesFilterSelectorProps> = ({
  selectedOfferTypes,
  setSelectedOfferTypes,
  availableOfferTypes,
}) => {
  const [toggle, setToggle] = useState(false);
  const onToggle = () => {
    setToggle(prevState => !prevState);
  };

  return (
    <FilterBarAccordion
      toggle={toggle}
      accordionTop={
        <OfferFilter
          title="OFFER TYPE"
          isOpen={toggle}
          onToggle={onToggle}
          icon="tag"
        />
      }
      accordionBody={
        <OfferTypesFilterSelector
          selectedOfferTypes={selectedOfferTypes ?? availableOfferTypes}
          setSelectedOfferTypes={setSelectedOfferTypes}
          availableOfferTypes={availableOfferTypes}
        />
      }
    />
  );
};

export default OfferTypesFilter;
